import classNames from 'classnames/bind';
import SuccessList from 'src/components/pages/sign-up/success-list/success-list';
import SuccessListItem from 'src/components/pages/sign-up/success-list/_item';
import Box from 'src/components/ui-kit/box/box';
import boxImage from 'public/images/oil-field.jpg';
import { DetailedHTMLProps, HTMLAttributes } from 'react';
import { useTranslation } from 'next-i18next';
import styles from './advantages.module.scss';
import Image from 'next/legacy/image';

const classesContext = classNames.bind(styles);

export default function Advantages({
  className,
  ...restProps
}: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element {
  const { t } = useTranslation(['components:pages:sign-up:advantages']);

  return (
    <Box
      className={classesContext(['advantages', className])}
      {...restProps}>
      <div className={styles.advantages_image}>
        <Image
          src={boxImage}
          alt={t('TEXT_OIL_FIELD')}
          layout='fill'
          objectFit='cover'
          sizes='(min-width: 1880px) 792px, (min-width: 1040px) calc(6.34vw + 674px), (min-width: 780px) 100vw, (min-width: 420px) calc(154.41vw - 45px), calc(38vw + 418px)'
          priority
        />
      </div>
      <h1 className={styles.advantages_title}>{t('TEXT_MINERAL_BUYER')}</h1>
      <SuccessList className={styles.advantages_list}>
        <SuccessListItem>{t('TEXT_NEW_LISTINGS_WEEKLY')}</SuccessListItem>
        <SuccessListItem>{t('TEXT_POWERFUL_LISTING_NAVIGATOR')}</SuccessListItem>
        <SuccessListItem>{t('TEXT_EMAIL_LISTING_ALERTS')}</SuccessListItem>
        <SuccessListItem>{t('TEXT_EXCLUSIVE_SELLERS')}</SuccessListItem>
      </SuccessList>
    </Box>
  );
}
